/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_3_ResultInputs */

const et_portfolio_project_3_result = /** @type {(inputs: Portfolio_Project_3_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müük kasvas 40% esimese kuu jooksul.`)
};

const en_portfolio_project_3_result = /** @type {(inputs: Portfolio_Project_3_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boosted sales by 40% within the first month.`)
};

/**
* | output |
* | --- |
* | "Boosted sales by 40% within the first month." |
*
* @param {Portfolio_Project_3_ResultInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_3_result = /** @type {((inputs?: Portfolio_Project_3_ResultInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_3_ResultInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_3_result(inputs)
	return en_portfolio_project_3_result(inputs)
});